// theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#5E2367", // il colore primario che vuoi di default
    },
    secondary: {
      main: "#4b4bff", // eventuale secondario
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        variant: "contained", // tutti i Button saranno 'contained'
        color: "primary", // e useranno 'primary' per default
      },
    },
  },
});

export default theme;
